import { z } from 'zod';

import { playerAttributesPayloadSchema } from './player';

export type CreatePlayerPayload = z.output<typeof createPlayerPayloadSchema>;
export type CreatePlayerPayloadDTO = z.input<typeof createPlayerPayloadSchema>;

export const createPlayerPayloadSchema = z.object({
  attributes: playerAttributesPayloadSchema.optional(),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
});
